<template>
  <template v-if="column.key === 'vehicle_type_id'">
    {{
      codeToText(record.vehicle_type_id || record.type_id, Enum.carModel.value)
    }}
  </template>
  <template v-else-if="column.key === 'color_id'">
    {{ codeToText(record.color_id, Enum.labelColor.value) }}
  </template>
  <template v-else-if="column.key === 'label_type_id'">
    {{ codeToText(record.label_type_id, Enum.labelType.value) }}
  </template>
  <template v-else-if="column.key === 'label_alarm_id'">
    {{ codeToText(record.alarm_id, Enum.labelAlarmType.value) }}
  </template>
  <template v-else-if="column.key === 'label_status'">
    {{ codeToText(record.status, Enum.labelStatus.value) }}
  </template>
  <template v-else-if="column.key === 'blackWhiteListType'">
    {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
  </template>
  <template v-else-if="column.key === 'status'">
    {{ codeToText(record.status, Enum.status.value) }}
  </template>
  <template v-else-if="column.key === 'time_range'">
    {{ record.start_time }} 至 {{ record.end_time }}
  </template>
  <template v-else-if="column.key === 'create_user_id'">
    {{ codeToText(record.create_user_id, Enum.user.value) }}
  </template>
  <template v-else-if="column.key === 'update_user_id'">
    {{ codeToText(record.update_user_id, Enum.user.value) }}
  </template>
  <template v-else-if="column.key === 'crossing_event_type'">
    {{ codeToText(record.event_type, gateCrossingType) }}
  </template>
  <template v-else-if="column.key === 'person_event_type'">
    {{ codeToText(record.event_type, personGateCrossingType) }}
  </template>
  <template v-else-if="column.key === 'crossing_strobe_state'">
    {{ codeToText(record.strobe_state, gateCrossingState) }}
  </template>
  <template v-else-if="column.key === 'open_result'">
    {{ codeToText(record.open_result, gateCrossingResult) }}
  </template>
  <template v-else-if="column.key === 'crossing_card_status'">
    {{ codeToText(record.card_status, gateCrossingCardType) }}
  </template>
  <template v-else-if="column.key === 'crossing_image_type'">
    {{ codeToText(record.image_type, gateCrossingVisitType) }}
  </template>
  <template v-else>{{ value }}</template>
</template>

<script setup>
  import { defineProps, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { codeToText } from '@/utils/format'
  import {
    gateCrossingType,
    gateCrossingState,
    gateCrossingResult,
    personGateCrossingType,
    gateCrossingCardType,
    gateCrossingVisitType,
  } from '@/utils/common'
  const store = useStore()
  const Enum = toRefs(store.state.common)
  //初始化
  const props = defineProps({
    column: {
      required: true,
    },
    record: {
      required: true,
    },
  })

  //计算属性
  const record = computed(() => {
    return props.column?.dataInObject
      ? props.record[props.column?.dataInObject]
      : props.record
  })
  const column = computed(() => {
    return props.column
  })
  const value = computed(() => {
    return record.value?.[column.value.key]
  })
</script>

<style lang="less" scoped></style>
